/* Base translations · Methodology and engagement type — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): meth, engagementType. */
export const I18N_BASE_METHODOLOGY = {
  en: {
    meth: {
      title: "Firm Methodology",
      purpose: "Upload PDF; the assistant extracts every method/rule; approve to activate.",
      add: "Add methodology", empty: "No methodology uploaded yet.",
      file: "File", status: "Status", uploadedBy: "Uploaded by", at: "At",
      approve: "Approve", reject: "Reject", rejectReason: "Reason",
      approvedOk: "Approved", uploadOk: "Methodology uploaded — extracting…",
      delete: "Delete", deleteConfirm: "Move this methodology version to the Recycle Bin?",
      approvedBy: "Approved by", extraction: "Extraction", rules: "rules", retry: "Retry", open: "Open",
      viewPdf: "View PDF", download: "Download", fileMissing: "File not available — please re-upload this version",
      aiSummary: "AI summary", summaryLbl: "AI summary", summaryNone: "No AI summary yet.", noRunEdition: "No AI pre-mark run yet for this edition",
      summaryDraft: "AI draft — review required", summaryApproved: "Approved summary",
      notCovered: "Not covered in this methodology", extractQueued: "Extraction queued", summaryQueued: "AI summary queued",
      tabSummary: "Summary", tabRules: "Rules", secRef: "Section", ruleTitle: "Title", ruleSummary: "Summary", page: "Page",
      headerBadge: "Methodology V{n}",
      st: { draft: "Draft", current: "Approved — Current", superseded: "Superseded", rejected: "Rejected" },
      ex: { queued: "Queued", extracting: "Reading the document…", done: "Done", failed: "Failed" },
      sm: { none: "—", queued: "Queued", running: "Running", ai_draft: "AI draft — review required", approved: "Approved", failed: "Failed" },
      sec: { materiality: "Materiality", sampling: "Sampling", risk_assessment: "Risk assessment",
             journal_entry_testing: "Journal entry testing criteria", analytical_procedures: "Analytical procedures",
             external_confirmations: "External confirmations", review_signoff: "Review and sign-off levels",
             documentation_archiving: "Documentation, assembly and archiving" },
    },
    engagementType: {
      label: "Engagement type",
      pickPlaceholder: "— pick an engagement type —",
      required: "Engagement type is required",
      comingSoonBadge: "Coming soon",
      notSet: "Not set",
      notSetHint: "Open Engagement Settings to pick the engagement type.",
      audit: "Audit of financial statements (ISAs)",
      review: "Review of financial statements (ISRE 2400 (Revised))",
      interim_review: "Interim review (ISRE 2410)",
      special_purpose: "Audit — special purpose framework (ISA 800 (Revised))",
      single_statement: "Audit — single statement / specific element (ISA 805 (Revised))",
      summary_fs: "Summary financial statements (ISA 810 (Revised))",
    },
  },
  ar: {
    meth: {
      title: "منهجية المكتب",
      purpose: "ارفع ملف PDF؛ يستخرج المساعد كل طريقة/قاعدة؛ اعتمد لتفعيلها.",
      add: "إضافة منهجية", empty: "لم تُرفع أي منهجية بعد.",
      file: "الملف", status: "الحالة", uploadedBy: "رفعه", at: "في",
      approve: "اعتماد", reject: "رفض", rejectReason: "السبب",
      approvedOk: "تم الاعتماد", uploadOk: "تم رفع المنهجية — جاري الاستخراج…",
      delete: "حذف", deleteConfirm: "نقل هذا الإصدار من المنهجية إلى سلة المحذوفات؟",
      approvedBy: "اعتمده", extraction: "الاستخراج", rules: "قاعدة", retry: "إعادة المحاولة", open: "فتح",
      viewPdf: "عرض PDF", download: "تنزيل", fileMissing: "الملف غير متاح — يرجى إعادة رفع هذا الإصدار",
      aiSummary: "ملخص الذكاء الاصطناعي", summaryLbl: "ملخص الذكاء الاصطناعي", summaryNone: "لا يوجد ملخص بعد.", noRunEdition: "لم يتم تشغيل التعليم المسبق بالذكاء الاصطناعي لهذا الإصدار بعد",
      summaryDraft: "مسودة ذكاء اصطناعي — تتطلب مراجعة", summaryApproved: "ملخص معتمد",
      notCovered: "غير مشمول في هذه المنهجية", extractQueued: "تمت جدولة الاستخراج", summaryQueued: "تمت جدولة الملخص",
      tabSummary: "الملخص", tabRules: "القواعد", secRef: "القسم", ruleTitle: "العنوان", ruleSummary: "الملخص", page: "الصفحة",
      headerBadge: "المنهجية \u2066V{n}\u2069",
      st: { draft: "مسودة", current: "معتمد — الحالي", superseded: "مُستبدل", rejected: "مرفوض" },
      ex: { queued: "في الانتظار", extracting: "جارٍ قراءة المستند…", done: "مكتمل", failed: "فشل" },
      sm: { none: "—", queued: "في الانتظار", running: "قيد التشغيل", ai_draft: "مسودة ذكاء اصطناعي — تتطلب مراجعة", approved: "معتمد", failed: "فشل" },
      sec: { materiality: "الأهمية النسبية", sampling: "العينات", risk_assessment: "تقييم المخاطر",
             journal_entry_testing: "معايير اختبار قيود اليومية", analytical_procedures: "الإجراءات التحليلية",
             external_confirmations: "المصادقات الخارجية", review_signoff: "مستويات المراجعة والتوقيع",
             documentation_archiving: "التوثيق والتجميع والأرشفة" },
    },
    engagementType: {
      label: "نوع الارتباط",
      pickPlaceholder: "— اختر نوع الارتباط —",
      required: "نوع الارتباط مطلوب",
      comingSoonBadge: "قريبًا",
      notSet: "غير محدد",
      notSetHint: "افتح إعدادات الارتباط لاختيار النوع.",
      audit: "مراجعة القوائم المالية (معايير ISA)",
      review: "الفحص المحدود للقوائم المالية (ISRE 2400 المُنقّح)",
      interim_review: "الفحص المرحلي (ISRE 2410)",
      special_purpose: "مراجعة — إطار خاص الغرض (ISA 800 المُنقّح)",
      single_statement: "مراجعة — قائمة مالية واحدة / عنصر محدد (ISA 805 المُنقّح)",
      summary_fs: "القوائم المالية المختصرة (ISA 810 المُنقّح)",
    },
  },
};

export default I18N_BASE_METHODOLOGY;
